<div class="row mt-5" *ngIf="planBenefits" role="region" aria-label="Plan Benefits">
  <div class="col-12">
    <app-card-container>
      <div class="row">
        <div class="col-12">
          <div class="header-text" id="plan-benefits-heading">Plan Benefits</div>
        </div>
      </div>

      <div class="table-scroll-wrapper">
        <div class="table-content">
          <div class="row mt-5 mb-3" role="row">
            <div class="table-title" role="columnheader" [ngClass]="getDescriptionColumnClass()">Description</div>
            <div class="col-2 table-title text-left" role="columnheader" *ngIf="getShowQuantity()">Qty</div>
            <div class="col-2 table-title text-right" role="columnheader" *ngIf="getShowYouPay()">You Pay</div>
            <div class="col-2 table-title text-right" role="columnheader" *ngIf="getShowYouSave()">{{ getYouSaveLabel() }}</div>
            <div class="col-12 border-gray mt-2"></div>
          </div>

          <div *ngFor="let group of planBenefits.groups" role="rowgroup">
            <div class="row">
              <div class="col-12 section-header mt-3 mb-2">{{ group.itemName }}</div>
            </div>

            <div class="row mt-2" role="row" *ngFor="let item of group.items">
              <div class="mb-3" role="cell" [ngClass]="getDescriptionColumnClass()">
                {{ item.description }}<span *ngIf="item.asteriskNotation" class="asterisk-notation font-bold">{{ item.asteriskNotation }}</span>
              </div>
              <div class="col-2 mb-3 text-left" role="cell" *ngIf="getShowQuantity()">{{ item.quantity }}</div>
              <div class="col-2 mb-3 currency-cell" role="cell" *ngIf="getShowYouPay()" [attr.aria-label]="item.youPay !== null && item.youPay !== undefined ? 'You Pay: ' + formatCurrency(item.youPay) : 'You Pay: not applicable'">
                <span class="currency-block" *ngIf="formatCurrencyNumber(item.youPay)">
                  <span class="currency-sign">$</span><span class="currency-value">{{ formatCurrencyNumber(item.youPay) }}</span>
                </span>
              </div>
              <div class="col-2 mb-3 currency-cell" role="cell" *ngIf="getShowYouSave()" [attr.aria-label]="item.youSave !== null && item.youSave !== undefined ? 'You Save: ' + formatCurrency(item.youSave) : 'You Save: not applicable'">
                <span class="currency-block" *ngIf="formatCurrencyNumber(item.youSave)">
                  <span class="currency-sign">$</span><span class="currency-value">{{ formatCurrencyNumber(item.youSave) }}</span>
                </span>
              </div>
              <div class="col-12 border-gray"></div>
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-3" *ngIf="planBenefits.exclusiveDiscountStatement && planBenefits.exclusiveDiscountStatement.trim()">
        <div class="col-12">
          <p class="exclusive-discount-text">{{ planBenefits.exclusiveDiscountStatement }}</p>
        </div>
      </div>

      <div class="row mt-3" *ngIf="planBenefits.exceptions && planBenefits.exceptions.length > 0" role="note" aria-label="Benefit exceptions">
        <div class="col-12">
          <div class="text-sm italic text-gray-600 mb-1" *ngFor="let exception of planBenefits.exceptions">
            <span class="footnote-notation font-bold">{{ exception.notation }}</span> {{ exception.text }}
          </div>
        </div>
      </div>

      <div class="row mt-4" *ngIf="ancillaryCodes && ancillaryCodes.trim()">
        <div class="col-12">
          <p class="ancillary-text">
            Additional Benefits are available as part of your plan,
            <a routerLink="/ancillary-benefits" class="ancillary-link">click here</a> for more details.
          </p>
        </div>
      </div>
    </app-card-container>
  </div>
</div>
